import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabaseClient';

export const useApplication = (applicationId) => {
  const [application, setApplication] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (applicationId) {
      fetchApplicationDetails();
    }
  }, [applicationId]);

  const fetchApplicationDetails = async () => {
    try {
      setLoading(true);

      // Fetch application with full candidate and RFQ details
      const { data, error: appError } = await supabase
        .from('applications')
        .select(`
          *,
          candidate:candidates(*),
          rfq:rfqs(*, client:clients(*))
        `)
        .eq('id', applicationId)
        .single();

      if (appError) throw appError;

      setApplication(data);
      setError(null);
    } catch (err) {
      console.error('Error fetching application details:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return { application, loading, error, refetch: fetchApplicationDetails };
};
